import { css } from '@emotion/core'

export const styles = {
  hr: css`
    border: 1px solid rgba(0, 0, 0, 0.05);
    width: 100%;
  `,
}
